export default "__VITE_ASSET__DQ84Ql81__"